import { AVAILABLE_LANGUAGES } from 'cityads-v3/i18n/utils';

export function pad(number) {
  if (number < 10) {
    return '0' + number;
  }
  return number;
}

const MILLISECONDS_LENGTH = 3;

export function toISOStringNoTZ(date) {
  return date.getFullYear() +
    '-' + pad(date.getMonth() + 1) +
    '-' + pad(date.getDate()) +
    'T' + pad(date.getHours()) +
    ':' + pad(date.getMinutes()) +
    ':' + pad(date.getSeconds()) +
    '.' + (date.getMilliseconds() / 1000).toFixed(MILLISECONDS_LENGTH).slice(-MILLISECONDS_LENGTH) +
    'Z';
}

const AVAILABLE_LANGUAGES_MINUS_EN = AVAILABLE_LANGUAGES.filter(language => language !== 'en');

export function requireMomentLocale(language) {
  if (AVAILABLE_LANGUAGES_MINUS_EN.indexOf(language) < 0) {
    return null;
  }

  return require(`moment/locale/${language}.js`);
}

export const HALF_YEAR_MILLISECONDS = 15897600000;
export const HALF_YEAR_DAYS = 184;
